import {config as numberPercentColumnConfig} from '../../common/NumberPercentColumn';

const prop = 'rNO';

export const config = (labels) =>
	numberPercentColumnConfig({
		id: 'openNotes',
		label: labels.openNotes,
		prop,
		getPartial: (item) => item[prop],
		getTotal: (item) => item['rNTotal'],
		width: 'minmax(var(--px-150), 1fr)'
	});
